import React, { useMemo } from 'react';
import { getTheme, IconButton, Modal, Stack } from '@fluentui/react';
import { closeButtonStyles, imageStyles } from '../../SelectedWidgets.styles';
import { IEnlargeWidgetsProps } from '../../types';
import IvicosStrings from 'kits/language/stringKit';

import ArtGalleryInfo from './ArtGalleryInfo';
import ImageUploadInfo from './ImageUploadInfo';
import QuoteInfo from './QuoteInfo';
import BookInfo from './BookInfo';
import URLInfo from './URLInfo';

const theme = getTheme();

const EnlargeWidgets: React.FC<IEnlargeWidgetsProps> = ({ showImageModal, setShowImageModal, enlargeContent, type }) => {
    const { imageUrl, alt: altText } = enlargeContent || {};
    const handleClose = useMemo(() => () => setShowImageModal(false), [setShowImageModal]);

    return (
        <Modal
            isOpen={showImageModal}
            onDismiss={handleClose}
            isBlocking={false}
            styles={{
                main: {
                    width: '70vw',
                    height: 'auto',
                    borderRadius: 10,
                    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.4)'
                }
            }}
        >
            <Stack tokens={{ childrenGap: 16 }} style={{ padding: 16, backgroundColor: theme.palette.neutralLighter }}>
                <Stack horizontal horizontalAlign="end" verticalAlign="center">
                    <IconButton
                        iconProps={{ iconName: 'Cancel' }}
                        ariaLabel={IvicosStrings.personalMeetingCornerStrings.createWidget.close}
                        onClick={handleClose}
                        styles={closeButtonStyles}
                    />
                </Stack>

                {imageUrl && <img src={imageUrl} alt={altText || 'widget-image'} style={imageStyles} />}

                <Stack verticalAlign="center" horizontalAlign="center" style={{ margin: '20px auto' }}>
                    <ArtGalleryInfo type={type} content={enlargeContent} />
                    <ImageUploadInfo type={type} content={enlargeContent} />
                    <QuoteInfo type={type} content={enlargeContent} />
                    <BookInfo type={type} content={enlargeContent} />
                    <URLInfo type={type} content={enlargeContent} />
                </Stack>
            </Stack>
        </Modal>
    );
};

EnlargeWidgets.displayName = 'EnlargeWidgets';

export default React.memo(EnlargeWidgets);
